import { useMemo } from 'react'

import { type ObservabilityTool } from 'components/status-checks/authentication-form-utils'
import {
  DEFAULT_QUERY_STATUS_CHECKS_STALE_TIME,
  getExistingStatusCheckByMonitorUrl
} from 'components/status-checks/status-checks-form-utils'
import { useGetStatusChecksAsServiceStatusChecks } from 'queries/status-checks/use-get-status-checks-as-service-status-checks'
import { type EndpointConfiguration } from 'types/api/status-checks/status-check'

/**
 * Returns a matched Health Check, if one exists, based on the selected observability tool
 * and user-input Monitor URL.
 */
export function useGetExistingStatusCheckByMonitorUrl(
  observabilityTool: ObservabilityTool,
  monitorUrl: string | undefined,
  requestMethod?: EndpointConfiguration['method']
) {
  const { data: existingStatusChecks, isSuccess } =
    useGetStatusChecksAsServiceStatusChecks({
      enabled: Boolean(monitorUrl),
      retryOnMount: false,
      staleTime: DEFAULT_QUERY_STATUS_CHECKS_STALE_TIME
    })

  return useMemo(() => {
    if (!isSuccess || !monitorUrl) {
      return
    }

    return getExistingStatusCheckByMonitorUrl(
      existingStatusChecks,
      observabilityTool,
      monitorUrl,
      requestMethod
    )
  }, [
    existingStatusChecks,
    isSuccess,
    observabilityTool,
    monitorUrl,
    requestMethod
  ])
}
